import styled from 'styled-components';
const HeaderWrapper = styled.div`
    .ant-layout-header{
        line-height:0;
        background:#036822;
        height:100px;
        width:100%;
        margin:0;
    }
    .logos{
        &>img{
            width: 25%;
        }
    }
    .list-items{
        position:relative;
        top:13px;
        margin: 5px 0 0 0 ;
        &> li{
            cursor:pointer;
            font-size:14px;
            &.active{
                &::after{
                    content: ' ';
                    top: 10px;
                    height: 3px;
                    background: white;
                    border-radius: inherit;
                    display: block;
                    position: relative;
                    border-radius: 10px 10px 0 0;               
                }
            }
            
        }
    }

    .logout-btn{
        padding:0 30px;
        background:white;
        color:var(--main-color);
        border-radius:5px;
        border:none;
    }
    .trigger {
        padding: 0 24px;
        font-size: 18px;
        line-height: 64px;
        cursor: pointer;
        transition: color 0.3s;
        border:none;
        background:transparent;
        outline:none;
        &:hover{
            color: #1890ff;
        }
    }
    .user-info{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-top: 20px;
        color:white;
        
    }
    .sidebar-logout-btn{
        width:100% !important;
        height:39px !important;
        background:transparent !important;
        border:1px solid white !important;
        color:white !important;
        border-radius:3px !important;
    }
    .action-btn {
        border-radius: 10px;
        opacity: 1;
        border: none;
        color: white;
        &.submit-btn {
          background: var(--main-color);
        }
        &.back-btn {
          background: white;
          border: 1px solid var(--main-color);
          color: var(--main-color);
        }
      }

`;

export default HeaderWrapper;